import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step6 } from '../../../../../shared/models/component-messages/mapaAT/step6';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { AttributionFromMAPA } from '../../models/AttributionFromMAPA';

@Component({
  selector: 'app-step6',
  templateUrl: './step6.component.html'
})
export class Step6Component implements OnInit {

  @Input() attributionFromMAPA: AttributionFromMAPA;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

  public step6 = new Step6();

  constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService) { }

  ngOnInit(): void {
  }

  getUid() {
    return this.uid + '_SepSep_AttributionFromMAPA';
  }
}
